import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { RateLimitService } from '../../services/rate-limit.service';

interface IeditRateLimitProfileModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-edit-rate-limit-profile',
  templateUrl: './edit-rate-limit-profile.component.html',
  styleUrls: ['./edit-rate-limit-profile.component.scss'],
})
export class EditRateLimitProfileComponent implements OnInit {
  success: any;
  error: any;
  profileForm: FormGroup;
  pending: boolean;
  extraData: any;
  formSubmitAttempt: boolean;
  constructor(
    public modal: SuiModal<IeditRateLimitProfileModalContext, void, void>,
    private fb: FormBuilder,
    private rateLimitSvc: RateLimitService
  ) {
    this.profileForm = this.fb.group({
      profileName: ['', Validators.required],
      response: ['', Validators.required],
      interval: ['', Validators.required],
      requests: ['', Validators.required],
    });
    this.extraData = this.modal.context.data;
    this.profileForm.patchValue(this.extraData);
  }

  isFieldValid(field: string) {
    return (
      (!this.profileForm.get(field).valid &&
        this.profileForm.get(field).touched) ||
      (this.profileForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  ngOnInit(): void {
    this.profileForm.valueChanges.subscribe((changes) => {
      if (changes.interval) {
        if (!isNaN(changes.interval)) {
          if (changes.interval < 1) {
            this.profileForm.patchValue({ interval: 1 });
          }
        } else {
          this.profileForm.patchValue({ interval: '' });
        }
      }
    });
  }

  update() {
    this.pending = false;
    if (this.profileForm.valid) {
      this.error = null;
      this.pending = true;
      this.success = null;
    }
    if (this.modal.context.data) {
      this.rateLimitSvc
        .editRateLimitProfile({
          rateLimitProfileId: this.modal.context.data.profileId,
          body: {
            profileName: this.profileForm.value.profileName,
            responseMessage: this.profileForm.value.response,
            quota: this.profileForm.value.requests,
            interval: this.profileForm.value.interval,
          },
        })
        .subscribe({
          next: () => {
            this.pending = false;
            this.success = 'Rate Limit Profile Updated';
            setTimeout(() => this.modal.approve(), 500);
          },
          error: (error: any) => {
            this.error = error?.error?.message ? error?.error?.message : error;
            this.pending = false;
          },
        });
    }
  }
}

export class editRateLimitProfileModal extends ComponentModalConfig<
  IeditRateLimitProfileModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(EditRateLimitProfileComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
